import React, { useState, useEffect, useContext } from "react";
import SupplierDateReadOnlyRow from "./SupplierDateReadOnlyRow";
import SupplierDateTableRow from "./SupplierDateTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function SupplierDateTable({ key, setDate, partner, supplierCompanyId, resetMenu }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const [error, setError] = useState("");
	const [isSupplierDateLoading, setIsSupplierDateLoading] = useState(false);
	const [supplierDates, setSupplierDates] = useState([]);
	const [count, setCount] = useState(0);
	const [editableRecord, setEditableRecord] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		partnershipKey: partner.partnershipKey,
		supplierCompanyId: supplierCompanyId,
		clientCompanyId: partner.clientCompanyId,
		partnershipDateKey: 0,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		fetchSupplierDates();
	}, []);

	const handleClose = (event) => {
		setDate(false);
		if (resetMenu) {
			resetMenu();
		}
	};

	function fetchSupplierDates() {
		setError("");
		if (!initialValues.supplierCompanyId || initialValues.supplierCompanyId === 0
			|| !initialValues.partnershipKey || initialValues.partnershipKey === 0
			|| !initialValues.clientCompanyId || initialValues.clientCompanyId === 0) {
			return;
		}
		resetCounter();
		setSupplierDates([]);
		setIsSupplierDateLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, supplierKey: initialValues.supplierCompanyId,
				partnershipKey: initialValues.partnershipKey, buyerKey: initialValues.clientCompanyId,
				userCompanyId: userCompanyId,
				includeInactivePartner: true
			}),
		};
		try {
			FetchUtil.fetchAPI("GetPartnerDates", "/Service/CompanyService/GetPartnerDates", requestOptions, retrievePartnerDateSuccess, retrievePartnerDateFail);
		} catch (error) {
			setIsPartnerSurveyLoading(false);
			throw new Error(error.message);
		}
	}

	function retrievePartnerDateFail(redirect) {
		setIsSupplierDateLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.partnerGetDateFailed"));
	}

	function retrievePartnerDateSuccess(responseData) {
		let getPartnerDatesResponse;
		if (responseData) {
			getPartnerDatesResponse = responseData.getPartnerDatesResponse;
			if (getPartnerDatesResponse && getPartnerDatesResponse.errorCode === "0") {
				setSupplierDates(getPartnerDatesResponse.supplierDates.slice())
			} else if (getPartnerDatesResponse && getPartnerDatesResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getPartnerDatesResponse) {
				setError(t("error.error") + " " + getPartnerDatesResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsSupplierDateLoading(false);
	}

	const handleDeleteClick = (event, partnerDateItem, completeCallback) => {
		event.preventDefault();
		deletePartnerDate(partnerDateItem, completeCallback);
	};
	const deletePartnerDate = (partnerDateItem, completeCallback) => {
		let action = 3;
		if (partnerDateItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			partnershipDateKey: partnerDateItem.partnershipDateKey,
			supplierCompanyId: partnerDateItem.supplierKey,
			partnershipKey: partnerDateItem.partnershipKey,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeletePartnerDate", "/Service/CompanyService/DeletePartnerDate", requestOptions, deletePartnerDateSuccess, deletePartnerDateFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deletePartnerDateFail(redirect, completeCallback) {
		setError(t("error.partnerDateEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deletePartnerDateSuccess(responseData, completeCallback) {
		let deletePartnerDateResponse;
		if (responseData) {
			deletePartnerDateResponse = responseData.deletePartnerDateResponse;
			if (deletePartnerDateResponse) {
				if (deletePartnerDateResponse.errorCode === "0") {
					setAdd(false);
					fetchSupplierDates();
				} else {
					setError(t("error.error") + " " +
						deletePartnerDateResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTable = () => {
		setError("");
		if(isEditMode){
			setError(t("error.onlyOneOpAllowed"));
		} else {
			if (!add) {
				setAdd(true);
			} else {
				setError(t("error.only1RowAllowed"));
			}
		}
	};
	const removeRowTable = () => {
		setError("");
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		
		if(validateFields(setValues)){
			if (action === 1) {
				savePartnerDate(action, setValues, completeCallback);
			} else if (action === 2) {
				if (supplierDates.length > 0) {
					supplierDates.map((supplierDateItem, index) => {
						if (supplierDateItem.partnershipDateKey === setValues.partnershipDateKey) {
							found = true;
						}
					})
				}
				if (found) {
					savePartnerDate(action, setValues, completeCallback);
				} 
			} 
			if (completeCallback) {
				completeCallback();
			}
		} else {
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		
	};
	const validateFields =(fieldValues) => {
		if (!formValues.supplierCompanyId || formValues.supplierCompanyId === 0
			|| !formValues.partnershipKey || formValues.partnershipKey === 0) {
			setError(t("error.partnerDateEditFailed"));
			return false;
		}
		let startDate;
		let endDate;

		if(!fieldValues.startDate){
			setError(t("error.startdateReqd"));
			return false;
		}
		if(fieldValues.startDate instanceof Object){
			startDate = fieldValues.startDate.getTime();
		} else {
			startDate = new Date(fieldValues.startDate).getTime();
		}
		if(fieldValues.endDate){
			if(fieldValues.endDate instanceof Object){
				endDate = fieldValues.endDate.getTime();
			} else {
				endDate = new Date(fieldValues.endDate).getTime();
			}
			if (startDate > endDate) {
		    	setError(t("error.endDateBeforeStartDate"));
		    	return false;
		  	} 
		  	
		  	/*supplierDates.forEach(supplierDate => {
				supplierStartDate = new Date(supplierDate.startDate).getTime();
			    if(supplierDate.endDate){
					supplierEndDate = new Date(supplierDate.endDate).getTime();
					if(startDate < supplierEndDate && supplierStartDate < endDate) {
				    	setError(t("error.datesOverlap"));
				    	return false;
				  	} 
				} else {
					if(supplierStartDate < endDate){
						setError(t("error.datesOverlap"));
				    	return false;
					}
				}
			});
		} else {
			supplierDates.forEach(supplierDate => {
				supplierStartDate = new Date(supplierDate.startDate).getTime();
			    if(supplierDate.endDate){
					supplierEndDate = new Date(supplierDate.endDate).getTime();
					if(startDate < supplierEndDate) {
				    	setError(t("error.datesOverlap"));
				    	return false;
				  	} 
				} else {
					setError(t("error.datesOverlap"));
				    return false;
				}
			});*/
		}
		return true;
	};
	const savePartnerDate = (action, setValues, completeCallback) => {
		let serverParams = {
			partnershipDateKey: setValues.partnershipDateKey,
			supplierCompanyId: formValues.supplierCompanyId,
			partnershipKey: formValues.partnershipKey,
			clientCompanyId: formValues.clientCompanyId,
			startDate: setValues.startDate,
            endDate: setValues.endDate,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		//alert(JSON.stringify(serverParams));
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdatePartnerDate", "/Service/CompanyService/AddUpdatePartnerDate", requestOptions, savePartnerDateSuccess, savePartnerDateFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function savePartnerDateFail(redirect, completeCallback) {
		setError(t("error.partnerDateEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function savePartnerDateSuccess(responseData, completeCallback) {
		let addUpdatePartnerDateResponse;
		if (responseData) {
			addUpdatePartnerDateResponse = responseData.addUpdatePartnerDateResponse;
			if (addUpdatePartnerDateResponse) {
				if (addUpdatePartnerDateResponse.errorCode === "0") {
					setAdd(false);
					fetchSupplierDates();
				} else {
					setError(t("error.error") + " " +
						addUpdatePartnerDateResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isSupplierDateLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.startDate")}</th>
										<th className="list-th" style={{ maxWidth: "25vw" }}>{t("page.endDate")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "15vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTable}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add &&
										<SupplierDateTableRow
											index={count}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((supplierDates.length % 2) > 0) ? true : false} />
									}
									{(supplierDates.length > 0) ? (
										supplierDates.map((partnerDateItem, index) => (
											<SupplierDateReadOnlyRow
												index={count}
												t={t}
												partnerDateItem={partnerDateItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												add={add}
												setIsEditMode={setIsEditMode}
												isEditMode={editableRecord == index? isEditMode: false}
												setError={setError}
												handleSubmit={handleSubmit}
												setEditableRecord={setEditableRecord}
												rowCount={index}
											/>
										))
									) : (<></>)}
								</tbody>
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-supplier-date-close"
									id="edit-supplier-date-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default SupplierDateTable;